// Basic
import PropTypes from 'prop-types';
// Components
import Switch from '@/common-utils/components/ui/switch';
// Common
import createDataCyAttribute from '@/common-utils/functions/createDataCyAttribute';
//Lang
import { nsUser } from '@/app/i18n/namespaces';

/**
 *
 * @param props
 * @param props.permission
 * @param props.userPermissions
 * @param props.setUserPermissions
 * @param props.isChecked
 * @returns SwitchPermissions component
 */
function SwitchPermissions({ permission, userPermissions, setUserPermissions, isChecked }) {

    const addPermission = () => {
        // [...userPermissions] is a way to copy userPermissions array..
        // .. and to dissociate old userPermission values from the new one
        // - With a simple copy with "=" newPermissionList and userPermissions would be the same referenced array
        const newPermissionList = [...userPermissions];
        // Push the permission to add
        newPermissionList.push(permission);
        // Update userPermissions
        setUserPermissions(newPermissionList);
    };

    const removePermission = () => {
        // Same case as seen above
        const newPermissionList = [...userPermissions.filter(filter => filter !== permission)];
        // Update userPermissions
        setUserPermissions(newPermissionList);
    };

    return (
        <Switch
            name={permission}
            checked={isChecked}
            onCheckedChange={(value) => {
                if (value) {
                    addPermission();
                } else {
                    removePermission();
                }
            }}
            entity={`permissions.${permission}`}
            namespace={nsUser}
            data-cy={createDataCyAttribute(permission, 'checkbox-permissions-')}
        />
    );
}
SwitchPermissions.propTypes = {
    permission: PropTypes.string.isRequired,
    userPermissions: PropTypes.array.isRequired,
    setUserPermissions: PropTypes.func.isRequired,
    isChecked: PropTypes.bool.isRequired
};

export default SwitchPermissions;